import './DateRangeFilter.scss';

import React from 'react';

import type { DateRange as Range } from '../../../models';
import bem from '../../../utils/bem';
import Button from '../../Button';
import type { DefaultRangeType } from '../../DateRange';
import { DateRange } from '../../DateRange';
import { isStartDateAfterEndDate } from '../hooks/utils';

export const [block] = bem('change-log-filter');

type Props = {
  dateRange: Range;
  onDateRangeChange: (field: 'start' | 'end', value: string) => void;
  onFilterSubmit: () => void;
  onClearFilter: () => void;
};

export const DateRangeFilter = ({
  dateRange,
  onClearFilter,
  onDateRangeChange,
  onFilterSubmit,
}: Props): React.JSX.Element => {
  const isFilterButtonDisabled = !dateRange.startDate || isStartDateAfterEndDate(dateRange);
  const isClearButtonDisabled = !dateRange.startDate && !dateRange.endDate;

  const formattedDateRange: DefaultRangeType = {
    start: dateRange.startDate,
    end: dateRange.endDate,
  };

  return (
    <div className={block()}>
      <DateRange dateRange={formattedDateRange} onChange={onDateRangeChange} type="date" />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button disabled={isFilterButtonDisabled} onClick={onFilterSubmit}>
          Filter
        </Button>
        <Button disabled={isClearButtonDisabled} onClick={onClearFilter}>
          Clear
        </Button>
      </div>
    </div>
  );
};
